import generateID from '../reducer/generateID';

export const createQuestion = (props) => {
  return {
    type: "CREATE_QUESTION",
    props: props,
    id: generateID()
  }
}

export const updateQuestion = (id, props) => {
  return {
    type: "UPDATE_QUESTION",
    props: props,
    id: id
  }
}

export const deleteQuestion = (id) => {
  return {
    type: "DELETE_QUESTION",
    id: id
  }
}

export const UPDATE_SORT_INDEXES = 'UPDATE_SORT_INDEXES';

export const updateSortIndexes = (section, questionsInOrder) => {
  return {
    type: UPDATE_SORT_INDEXES,
    questions: questionsInOrder,
    section
  }
}